import { motion } from 'framer-motion';

export function PortfolioSection() {
  const portfolioItems = [
    {
      category: '동부 코스',
      title: '성산일출봉 & 섭지코지',
      image: 'https://public.readdy.ai/ai/img_res/cd74798841ae2c2a273b88d438c79eac.jpg',
      description: '일출의 감동과 제주 동부의 숨은 명소를 경험하는 특별한 여행'
    },
    {
      category: '서부 코스',
      title: '협재해수욕장 & 오설록',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20turquoise%20water%20at%20Hyeopjae%20Beach%20Jeju%20with%20white%20sand%20and%20clear%20blue%20sky%2C%20pristine%20coastal%20scenery%20with%20emerald%20ocean%2C%20professional%20travel%20photography%20with%20vibrant%20natural%20colors%20and%20simple%20clean%20background&width=800&height=600&seq=portfolio-west-001&orientation=landscape',
      description: '에메랄드빛 바다와 제주 서부의 낭만을 만끽하는 감성 여행'
    },
    {
      category: '한라산 코스',
      title: '백록담 등반 투어',
      image: 'https://readdy.ai/api/search-image?query=Majestic%20Hallasan%20mountain%20peak%20with%20Baengnokdam%20crater%20lake%20surrounded%20by%20autumn%20foliage%2C%20stunning%20volcanic%20landscape%20of%20Jeju%20highest%20mountain%2C%20professional%20nature%20photography%20with%20clear%20blue%20sky%20and%20vibrant%20colors%2C%20simple%20natural%20background&width=800&height=600&seq=portfolio-hallasan-002&orientation=landscape',
      description: '전문 가이드와 함께하는 안전하고 감동적인 한라산 정복'
    },
    {
      category: '맛집 코스',
      title: '로컬 맛집 투어',
      image: 'https://readdy.ai/api/search-image?query=Delicious%20Jeju%20black%20pork%20grilling%20on%20traditional%20Korean%20BBQ%20grill%20with%20fresh%20side%20dishes%2C%20authentic%20local%20Korean%20food%20photography%20with%20appetizing%20presentation%2C%20professional%20culinary%20photography%20with%20warm%20lighting%20and%20simple%20clean%20background&width=800&height=600&seq=portfolio-food-001&orientation=landscape',
      description: '로컬만 아는 진짜 제주 맛을 경험하는 미식 여행'
    },
    {
      category: '웨딩 스냅',
      title: '제주 감성 웨딩 촬영',
      image: 'https://readdy.ai/api/search-image?query=Romantic%20wedding%20couple%20photoshoot%20at%20scenic%20Jeju%20coastline%2C%20bride%20in%20flowing%20white%20dress%20and%20groom%20in%20elegant%20suit%20walking%20on%20beach%2C%20golden%20hour%20soft%20lighting%20with%20ocean%20backdrop%2C%20professional%20Korean%20destination%20wedding%20photography%20with%20simple%20natural%20background&width=800&height=600&seq=portfolio-wedding-002&orientation=landscape',
      description: '제주의 아름다운 자연을 배경으로 한 로맨틱 웨딩 촬영'
    },
    {
      category: '올레길 투어',
      title: '제주 올레길 힐링',
      image: 'https://readdy.ai/api/search-image?query=Peaceful%20Jeju%20Olle%20trail%20walking%20path%20along%20dramatic%20coastline%20with%20green%20fields%20and%20ocean%20cliffs%2C%20serene%20hiking%20route%20through%20natural%20landscape%2C%20professional%20travel%20photography%20with%20soft%20natural%20colors%20and%20simple%20clean%20background&width=800&height=600&seq=portfolio-olle-002&orientation=landscape',
      description: '제주의 자연과 하나되는 여유로운 힐링 여행'
    }
  ];

  return (
    <section id="portfolio" className="py-20 sm:py-24 md:py-28 bg-white">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-8">
        {/* Header */}
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 sm:mb-20"
        >
          <div className="inline-flex items-center gap-3 bg-[#4A7C59]/10 px-6 py-3 rounded-full mb-6 sm:mb-8">
            <i className="ri-image-line text-[#4A7C59] text-lg sm:text-xl"></i>
            <span className="text-[#4A7C59] text-base sm:text-lg font-medium">여행 포트폴리오</span>
          </div>
          <h2 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#2C2C2C] mb-6 sm:mb-8 px-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
            제주블리와 함께한<br />특별한 순간들
          </h2>
          <p className="text-lg sm:text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto px-4 leading-relaxed">
            고객님들과 함께 만들어온<br />
            소중한 제주 여행의 추억들
          </p>
        </motion.div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {portfolioItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
                <div className="relative h-64 sm:h-72 md:h-80 overflow-hidden">
                  <img 
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute top-4 left-4">
                    <span className="bg-white/95 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-bold text-[#2C2C2C]">
                      {item.category}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-4 group-hover:translate-y-0 transition-transform">
                    <h3 className="text-2xl font-bold mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm text-white/90 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* CTA Section */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-20 text-center"
        >
          <div className="bg-gradient-to-br from-[#0E7FC0] to-[#0a5f92] rounded-3xl p-12 sm:p-16 text-white">
            <h3 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
              당신만의 특별한 제주 이야기를<br />
              함께 만들어가요
            </h3>
            <p className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-10 text-white/90 max-w-2xl mx-auto">
              로컬 전문가가 큐레이션하는 진짜 제주를 경험하세요
            </p>
            <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
              <a 
                href="tel:010-5685-7818" 
                className="bg-white text-[#0E7FC0] px-10 py-5 rounded-full text-xl font-bold hover:bg-gray-100 transition-all flex items-center justify-center gap-3 whitespace-nowrap shadow-xl hover:scale-105"
              >
                <i className="ri-phone-line text-2xl"></i>
                010-5685-7818
              </a>
              <button 
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="bg-[#FF8E53] text-white px-10 py-5 rounded-full text-xl font-bold hover:bg-[#ff7a3d] transition-all flex items-center justify-center gap-3 whitespace-nowrap shadow-xl hover:scale-105"
              >
                <i className="ri-message-3-line text-2xl"></i>
                실시간 상담
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
